import React from 'react';
import SupplierTable from './SupplierTable';

function SignalSuppliersTable({ suppliers, remainedTotal }) {
  return (
    <SupplierTable
      title="Compensi da segnalazioni"
      suppliers={suppliers}
      anchorId="info-signals"
      remainedTotal={remainedTotal}
    />
  );
}

export default SignalSuppliersTable;
